import { Component, Input } from '@angular/core';
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faBan,
  faRectangleLandscape,
  faCalendar
} from '@fortawesome/pro-regular-svg-icons';
import { Ticket } from 'src/app/services/ticket.model';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss'],
})
export class TicketComponent {
    @Input() ticket: Ticket;
    @Input() admin: boolean;

    expanded: boolean = false;

    get timeUnanswered(): number {
        let now: any = new Date;
        now = now.getTime();
        return Math.round((now-this.ticket.createdAt)/1000/60/60/24);
    }

    constructor(public ticketService: TicketService) {}

    // icons
    angleDown = faAngleDown;
    angleUp = faAngleUp;
    check = faCheck;
    ban = faBan;
    rectangleLandscape = faRectangleLandscape
    calendar = faCalendar

}
